import CommonList from "../../../common/list";
import React, {useEffect, useState} from "react";
import {columns} from "./columns/columns";
import TableTitle from "../../../common/list/components/TableTitle";
import {useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";
import {getAllWeighingStations} from "../../../api/weighingStation";
import {DG_Format_Status} from "../../../format/Status";
import EditParent from "./editParent";
import EditParentCustomer from "../customer/editParent";

const WeighingStation = () => {

    const [searchParams] = useSearchParams();
    const {reloadData} = useSelector(state => state.layoutInteractionReducer)
    const [dataSource, setDatSource] = useState()
    const [total, setTotal] = useState()
    const [visible, setVisible] = useState(false)
    const [id, setId] = useState()
    const [name, setName] = useState()
    const [visibleCustomer, setVisibleCustomer] = useState()
    const [idCustomer, setIdCustomer] = useState()
    const [nameCustomer, setNameCustomer] = useState()

    const getPhoneNumber = (data) =>{
        let subString = "\\+"
        if (data !== undefined && data !== ""){
            if (data.match(new RegExp(subString)) !== null ){
                return data.replace(/(\+\d{2})(\d{3})(\d{3})(\d{3})/, '($1) $2 $3 $4');
            }else{
                return data.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3');
            }
        }

        return ""
    }

    const mapDatasource = (data) => {
        if (!data) {
            return [];
        }
        return data?.map((item) => {
            return {
                ...item,
                status: DG_Format_Status(item.status),
                customerName: <span style={{color: "#1890FF"}}
                                    onClick={() => {
                                        setVisibleCustomer(true)
                                        setIdCustomer(item.customerId)
                                        setNameCustomer(item.customerName)
                                    }}> {item.customerName} </span>,
                phoneNumber : getPhoneNumber(item.phoneNumber)
            };
        });
    }

    useEffect(() => {
        getAllWeighingStations(searchParams.get("page"),
            searchParams.get("pageSize"),
            searchParams.get("search")).then(r => {
            setDatSource(mapDatasource(r.data))
            setTotal(r.totalPage)
        })
            .catch(() => {
            })

    }, [searchParams, reloadData])

    return (
        <div className={"h-full"}>
            <TableTitle
                title={"Danh sách trạm cân"}
            />
            {
                dataSource && <CommonList
                    columns={columns}
                    totalCount={total}
                    dataSource={dataSource}
                    onRow={(record) => {
                        return {
                            onClick: () => {
                                setVisible(true)
                                setId(record.id)
                                setName(record.weighingStationName)
                            }
                        }
                    }}
                />
            }
            <EditParent id={id}
                        name={name}
                        visible={visible}
                        onCancel={() => {
                            setVisible(false)
                            setId(undefined)
                            setName(undefined)
                        }}/>
            <EditParentCustomer id={idCustomer}
                        visible={visibleCustomer}
                        onCancel={() => {
                            setVisibleCustomer(false)
                            setIdCustomer(undefined)
                            setNameCustomer(undefined)
                        }}
                        name={nameCustomer}/>
        </div>
    )
}
export default WeighingStation
